
import vpsPageData from "../../data/vps";

export default {
  data() {
    return {
      items: vpsPageData.uses,
      uses: vpsPageData.uses,
    };
  },
};
